interface ErrorStateProps {
  title: string
  description: string
  ctaUrl?: string
  ctaLabel?: string
}

export function ErrorState({ title, description, ctaUrl, ctaLabel }: ErrorStateProps) {
  return (
    <main className="error-state" data-testid="error-state">
      <h1 className="error-state__title">{title}</h1>
      <p className="error-state__description">{description}</p>
      {ctaUrl ? (
        <a className="error-state__cta" href={ctaUrl}>
          {ctaLabel ?? 'Doe de quickscan opnieuw'}
        </a>
      ) : null}
    </main>
  )
}
